/**
 * 데이터 타입 감지 유틸리티 함수
 */

/**
 * 숫자 타입 여부 확인
 */
export const isNumericType = (dataType?: string): boolean => {
  if (!dataType) return false;
  const numericTypes = [
    'int',
    'integer',
    'bigint',
    'smallint',
    'tinyint',
    'float',
    'double',
    'decimal',
    'numeric',
    'number',
  ];
  return numericTypes.some((type) => new RegExp(`\\b${type}\\b`, 'i').test(dataType));
};

/**
 * 날짜/시간 타입 여부 확인
 */
export const isDateType = (dataType?: string): boolean => {
  if (!dataType) return false;
  const dateTypes = ['date', 'time', 'timestamp', 'datetime'];
  return dateTypes.some((type) => dataType.toLowerCase().includes(type));
};

/**
 * Boolean 타입 여부 확인
 */
export const isBooleanType = (dataType?: string): boolean => {
  if (!dataType) return false;
  const booleanTypes = ['boolean', 'bool', 'bit'];
  return booleanTypes.some((type) => dataType.toLowerCase().includes(type));
};
